import { useMemo, type ComponentProps } from "react";

import type { RoomStockTableMobile } from "..";

type Props = Pick<ComponentProps<typeof RoomStockTableMobile>, "selectedItemIDs" | "serverModel">;

export const useRoomStockTablePresenter = ({ serverModel, selectedItemIDs }: Props) => {
	const filteredViewModel = useMemo(() => {
		const { items } = serverModel.roomStock;
		const filteredItems = items.filter((item) => selectedItemIDs.includes(item.roomID));

		return { ...serverModel.roomStock, items: filteredItems };
	}, [serverModel, selectedItemIDs]);

	const [currentYear, currentMonth] = filteredViewModel.headers[0].date.split("-");

	return {
		filteredViewModel,
		currentYear,
		currentMonth,
	};
};
